// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rating span{font-size:1.1em}.rating__back-stars{display:flex;color:#bebebe;position:relative}.rating__front-stars{display:flex;overflow:hidden;position:absolute;top:0;transition:all 0.5s}\n", ""]);
// Exports
module.exports = exports;
